import { configService } from './config.service';
import { RestClient } from '../utils/rest-client';
const restClient = RestClient(configService.restConfig);
async function submitCrossword(code, data) {
    await restClient.post({
        openapiPath: '/crosswords/{Code}/submissions',
        pathParams: {
            Code: code,
        },
        requestBody: {
            Data: data,
        },
    });
    // if (!res.ok) {
    //   let errorBody;
    //   switch (res.status) {
    //     case 400:
    //       errorBody = await res.json();
    //       if (errorBody.erroCode === RESOURCENOTFOUND) {
    //         throw new Error('The quiz is no longer accessible');
    //       } else {
    //         throw new Error(
    //           'An unexpected error has occurred. Please contact administrator.'
    //         );
    //       }
    //     default:
    //       throw new Error(
    //         'An unexpected error has occurred. Please contact administrator.'
    //       );
    //   }
    // }
}
const crosswordService = { submitCrossword };
export { crosswordService };
